import React, { createContext, FC, ReactNode, useContext } from 'react'
import { GeckoSiteModel } from 'types'

export type SiteModelContextType = {
  siteModel: GeckoSiteModel
  setSiteModel: (newSiteModel: GeckoSiteModel) => void
}

export const SiteModelContext = createContext<SiteModelContextType | undefined>(
  undefined
)

export const SiteModelProvider: FC<
  SiteModelContextType & { children: ReactNode }
> = ({ children, ...props }) => {
  return (
    <SiteModelContext.Provider value={props}>
      {children}
    </SiteModelContext.Provider>
  )
}

export const useSiteModelContext = () => {
  const context = useContext(SiteModelContext)
  if (!context)
    throw new Error('useSiteModel() must be used within SiteModelProvider')
  return context
}
